import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentStatic = _resolveComponent("DocumentStatic")!
  const _component_DocumentStaticMobile = _resolveComponent("DocumentStaticMobile")!
  const _component_DocumentChat = _resolveComponent("DocumentChat")!
  const _component_DocumentToReupload = _resolveComponent("DocumentToReupload")!
  const _component_DocumentValidation = _resolveComponent("DocumentValidation")!
  const _component_DocumentValidationManagement = _resolveComponent("DocumentValidationManagement")!
  const _component_DocumentValidationMobile = _resolveComponent("DocumentValidationMobile")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(!_ctx.$vuetify.display.mobile ? '' : 'fill-height')
  }, [
    (_ctx.isStatic)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.$vuetify.display.mobile)
            ? (_openBlock(), _createBlock(_component_DocumentStatic, {
                mode: _ctx.mode,
                companyId: _ctx.companyId,
                inDocument: _ctx.document,
                previousIdIsset: _ctx.previousIdIsset,
                nextIdIsset: _ctx.nextIdIsset,
                "is-accounting-item": _ctx.isAccountingItem,
                key: `DocumentStatic_${_ctx.id}`,
                onTaskEnded: _ctx.onTaskEnded,
                onPrevious: _ctx.previous,
                onNext: _ctx.next,
                onBack: _ctx.back,
                onEdit: _ctx.onEdit,
                onDeleted: _ctx.deleted,
                onOpenReconciliation: _ctx.openReconciliation,
                onUpdating: _ctx.onUpdating
              }, null, 8, ["mode", "companyId", "inDocument", "previousIdIsset", "nextIdIsset", "is-accounting-item", "onTaskEnded", "onPrevious", "onNext", "onBack", "onEdit", "onDeleted", "onOpenReconciliation", "onUpdating"]))
            : (_openBlock(), _createBlock(_component_DocumentStaticMobile, {
                mode: _ctx.mode,
                companyId: _ctx.companyId,
                inDocument: _ctx.document,
                previousIdIsset: _ctx.previousIdIsset,
                nextIdIsset: _ctx.nextIdIsset,
                "is-accounting-item": _ctx.isAccountingItem,
                key: `DocumentStaticMobile_${_ctx.id}`,
                onTaskEnded: _ctx.onTaskEnded,
                onPrevious: _ctx.previous,
                onNext: _ctx.next,
                onBack: _ctx.back,
                onEdit: _ctx.onEdit,
                onOpenReconciliation: _ctx.openReconciliation,
                onUpdating: _ctx.onUpdating
              }, null, 8, ["mode", "companyId", "inDocument", "previousIdIsset", "nextIdIsset", "is-accounting-item", "onTaskEnded", "onPrevious", "onNext", "onBack", "onEdit", "onOpenReconciliation", "onUpdating"]))
        ], 64))
      : (_ctx.isChat)
        ? (_openBlock(), _createBlock(_component_DocumentChat, {
            mode: _ctx.mode,
            companyId: _ctx.companyId,
            inDocument: _ctx.document,
            previousIdIsset: _ctx.previousIdIsset,
            nextIdIsset: _ctx.nextIdIsset,
            onTaskEnded: _ctx.onTaskEnded,
            onPrevious: _ctx.previous,
            onNext: _ctx.next,
            onOpenReconciliation: _ctx.openReconciliation,
            onUpdating: _ctx.onUpdating,
            key: `DocumentChat_${_ctx.id}`
          }, null, 8, ["mode", "companyId", "inDocument", "previousIdIsset", "nextIdIsset", "onTaskEnded", "onPrevious", "onNext", "onOpenReconciliation", "onUpdating"]))
        : (_ctx.toReupload)
          ? (_openBlock(), _createBlock(_component_DocumentToReupload, {
              mode: _ctx.mode,
              companyId: _ctx.companyId,
              inDocument: _ctx.document,
              previousIdIsset: _ctx.previousIdIsset,
              nextIdIsset: _ctx.nextIdIsset,
              onTaskEnded: _ctx.onTaskEnded,
              onPrevious: _ctx.previous,
              onNext: _ctx.next,
              onOpenReconciliation: _ctx.openReconciliation,
              key: `DocumentToReupload_${_ctx.id}`
            }, null, 8, ["mode", "companyId", "inDocument", "previousIdIsset", "nextIdIsset", "onTaskEnded", "onPrevious", "onNext", "onOpenReconciliation"]))
          : (
                _ctx.toValidate && !_ctx.$vuetify.display.mobile && _ctx.selectedCompany.solution !== 'MANAGEMENT'
            )
            ? (_openBlock(), _createBlock(_component_DocumentValidation, {
                mode: _ctx.mode,
                companyId: _ctx.companyId,
                inDocument: _ctx.document,
                previousIdIsset: _ctx.previousIdIsset,
                nextIdIsset: _ctx.nextIdIsset,
                onTaskEnded: _ctx.onTaskEnded,
                onPrevious: _ctx.previous,
                onNext: _ctx.next,
                onOpenReconciliation: _ctx.openReconciliation,
                onBack: _ctx.back,
                onUpdating: _ctx.onUpdating,
                key: `DocumentValidation_${_ctx.id}`
              }, null, 8, ["mode", "companyId", "inDocument", "previousIdIsset", "nextIdIsset", "onTaskEnded", "onPrevious", "onNext", "onOpenReconciliation", "onBack", "onUpdating"]))
            : (
                _ctx.toValidate && !_ctx.$vuetify.display.mobile && _ctx.selectedCompany.solution === 'MANAGEMENT'
            )
              ? (_openBlock(), _createBlock(_component_DocumentValidationManagement, {
                  mode: _ctx.mode,
                  companyId: _ctx.companyId,
                  inDocument: _ctx.document,
                  previousIdIsset: _ctx.previousIdIsset,
                  nextIdIsset: _ctx.nextIdIsset,
                  onTaskEnded: _ctx.onTaskEnded,
                  onPrevious: _ctx.previous,
                  onNext: _ctx.next,
                  onOpenReconciliation: _ctx.openReconciliation,
                  onUpdating: _ctx.onUpdating,
                  key: `DocumentValidationManagement_${_ctx.id}`
                }, null, 8, ["mode", "companyId", "inDocument", "previousIdIsset", "nextIdIsset", "onTaskEnded", "onPrevious", "onNext", "onOpenReconciliation", "onUpdating"]))
              : (_ctx.toValidate && _ctx.document.status === 'ANALYSED' && _ctx.$vuetify.display.mobile)
                ? (_openBlock(), _createBlock(_component_DocumentValidationMobile, {
                    mode: _ctx.mode,
                    companyId: _ctx.companyId,
                    inDocument: _ctx.document,
                    previousIdIsset: _ctx.previousIdIsset,
                    nextIdIsset: _ctx.nextIdIsset,
                    onTaskEnded: _ctx.onTaskEnded,
                    onPrevious: _ctx.previous,
                    onNext: _ctx.next,
                    onBack: _ctx.back,
                    onOpenReconciliation: _ctx.openReconciliation,
                    onUpdating: _ctx.onUpdating,
                    key: `DocumentValidationMobile_${_ctx.id}`
                  }, null, 8, ["mode", "companyId", "inDocument", "previousIdIsset", "nextIdIsset", "onTaskEnded", "onPrevious", "onNext", "onBack", "onOpenReconciliation", "onUpdating"]))
                : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.beforeRouteLeaveDialog,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.beforeRouteLeaveDialog) = $event)),
      title: "Enregistrer ?",
      onValid: _cache[1] || (_cache[1] = ($event: any) => {
                _ctx.routeNext();
                _ctx.beforeRouteLeaveDialog = false;
            }),
      validTitle: 'Oui je suis sûr(e)',
      onClose: _cache[2] || (_cache[2] = ($event: any) => {
                _ctx.routeNext(false);
                _ctx.beforeRouteLeaveDialog = false;
            }),
      width: "800px"
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [
        _createElementVNode("h4", { class: "text-center" }, " Les modifications que vous avez apportées ne seront peut-être pas enregistrées. Êtes vous sûr(e) de vouloir changer de page ? ", -1)
      ])),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}